'use client'

import { clientConfig } from '@/src/config/client.config'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ThemeProvider } from 'next-themes'
import { ReactNode, Suspense } from 'react'
import { Toaster } from './ToastProvider'
import { TooltipProvider } from './TooltipProvider'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: false,
            refetchOnWindowFocus: false,
            // refetchOnReconnect: false,
        },
    },
})

export const Providers = ({ children }: { children: ReactNode }) => {
    return (
        // <MaintenanceModeProvider>
        // <SessionProvider session={session}>
        <QueryClientProvider client={queryClient}>
            {/* <ThemeProvider attribute="class" defaultTheme="dark" enableSystem> */}
            <ThemeProvider attribute="class" defaultTheme="dark" forcedTheme="dark">
                <TooltipProvider>
                    <Toaster />
                    {children}
                </TooltipProvider>
            </ThemeProvider>
            {clientConfig.showReactQueryDevTools ? (
                <Suspense fallback={null}>
                    <ReactQueryDevtools initialIsOpen={false} />
                </Suspense>
            ) : null}
        </QueryClientProvider>
        // </SessionProvider>
        // </MaintenanceModeProvider>
    )
}
